<template>
  <div class="nav-box">
    <div class="nav">
      <div 
        :class="['item', currentIndex === index ? 'active' : '']" 
        v-for="(item, index) of list"
        :key="item.id" 
        @click="onItemClick(index)"
      >
        <div class="name">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      list: []
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.$root.$el.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    init() {
      this.makeList()
      this.setFloorHeights()
      this.onScroll.bind(this)
      this.$root.$el.addEventListener('scroll', this.onScroll)
    },
    getFloorNodeRect() {
      const nodes = this.$parent.$el.querySelectorAll('.floor-item')
      let heights = [0], height = 0;
      nodes.forEach(node => {
        height += node.offsetHeight
        heights.push(height)
      })
      return heights
    },
    setFloorHeights() {
      this.$nextTick(() => {
        const run = () => {
          const nodes = this.$parent.$el.querySelectorAll('.floor-item')
          let heights = [0], height = 0
          nodes.forEach(node => {
            height += node.offsetHeight
            heights.push(Math.floor(height))
          })
          this.heights = this.list.map(item => heights[item.i])
          height = heights.pop()
          height && this.heights.push(height)
        }
        run()
        setTimeout(run, 3000)
        setTimeout(run, 3000)
      })
    },
    makeList() {
      const { componentList } = this.$parent.home
      const list = []
      componentList.forEach((floor, i) => {
        if(floor.naviTitle) {
          list.push({ i, id: floor.id, name: floor.naviTitle })
        }
      })
      this.list = list
    },
    onItemClick(index) {
      console.log(this.heights[index])
      this.$root.$el.scrollTop = this.heights[index] + 1
    },
    onScroll() {
      const scrollTop = this.$root.$el.scrollTop
      for(let i = 0; i < this.heights.length - 1; i++) {
        if(scrollTop >= this.heights[i] && scrollTop <= this.heights[i + 1]) {
          if(this.currentIndex !== i) {
            this.currentIndex = i
            return
          }
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.nav-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  color: #999999;
  font-size: 22px;
  overflow-x: hidden;
  overflow-y: auto;
}
.nav {
  flex: 1;
  background: #F2F2F2;
  box-sizing: border-box;
  padding: 16px 0;
  border-radius: 0 10px 10px 0;
}
.nav .item {
  padding: 10px 6px;
  border-bottom: 1px solid #ffffff;
  position: relative;
}
.nav .item:last-child {
  border-bottom: 0;
}
.nav .active {
  color: #ED3939;
  font-weight: bold;
  background-color: #ffffff;
}
.nav .active::after {
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 4px;
  background-color: #ED3939;
}
.nav .name {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.4;
  width: 56px;
  height: 60px;
  overflow-x: hidden;
}
</style>
